/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelExcisetaxChargeEdi.ts            *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/ar/excisetax-charge-edi";

export class AutogenModelExcisetaxChargeEdi<RowType extends ModelRow> extends Endpoint<RowType, RowExcisetaxChargeEdiFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowExcisetaxChargeEdi extends ModelRow<RowExcisetaxChargeEdiFields> {
	constructor(values?: Partial<RowExcisetaxChargeEdiFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowExcisetaxChargeEdiFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_type: string;
	company_id: string;
	customer_id: string;
	descr: string;
	direction: string;
	excisetax_id: string;
	id: string;
	invoice_id: string;
	method: string;
	order_excisetax_id: string;
	order_id: string;
	rate: number;
	state_id: string;
	tax_date: Date;
	units: number;
}

